import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectPrintOption,
  selectToolCollection,
  updateOption,
  updateDesignName,
} from "../../../actions";
import Dialog from "../../Dialog";
import PrintOptionFilter from "./PrintOptionFilter";
import OptionList from "./OptionList";
import "./StyleTools.css";
import localStorageWrapper from "../../../services/localStorageWrapper";

class StyleTools extends React.Component {
  state = {
    showRepousseDialog: false,
    showCustomPhotoFoilNote: false,
  };

  componentDidMount() {
    // Set 'Style' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Style" });

    this.dialog = {
      title: "Design Notice",
      message:
        "Selecting Foil & Embossed requires a special plate and will incur an additional $25 plate charge.",
      topPosition: 110,
      leftPosition: 60,
      origin: "topright",
    };

    this.customPhotoFoilNote = {
      title: "WARNING!",
      message:
        "NOTE: Upcharge applies for foil printing on custom photo products.",
      topPosition: 160,
      leftPosition: 10,
      origin: "topright",
      type: "warning",
    };
  }

  handleChoosePrintOption = (filterName, printOptionFilter) => {
    // find all product options that support this print option filter
    // since a new option has chosen, find all matching options. then look for the current option
    let options = this.filterOptions(filterName, printOptionFilter);

    // choose a new print option
    let newOption = options[0];
    let foundOption = options.find(
      (option) =>
        option.name.includes(this.props.design.name) ||
        this.props.design.name.includes(option.name),
    );
    if (foundOption) {
      newOption = foundOption;
    }

    this.props.selectPrintOption({
      filterName,
      printOptionFilter,
      option: newOption,
    });
    if (printOptionFilter === "Foil & Embossed") {
      this.setState({
        showRepousseDialog: true,
      });
    }

    if (printOptionFilter === "Photo & Full Color + FOIL") {
      this.setState({
        showCustomPhotoFoilNote: true,
      });
    } else {
      this.setState({
        showCustomPhotoFoilNote: false,
      });
    }
  };

  handleChooseOption = (option) => {
    const selectedFilters = this.getSelectedPrintOptionFilters();

    let foundPrintOptionIndex = null;
    option.print_options.forEach((printOption, index) => {
      let matchesAllFilters = true;
      selectedFilters.forEach((selectedFilter) => {
        let matchedFilter = false;
        printOption.filters.forEach((filter) => {
          if (
            filter.type_name === selectedFilter.type_name &&
            filter.value === selectedFilter.value
          ) {
            matchedFilter = true;
          }
        });
        matchesAllFilters = matchesAllFilters && matchedFilter;
      });
      if (matchesAllFilters) {
        foundPrintOptionIndex = index;
      } else {
        // I hope we don't get to this point.
        //TODO add some kind of error support to the UI
      }
    });

    this.props.updateOption({
      selectedPrintOption: foundPrintOptionIndex,
      option,
    });
    this.props.updateDesignName(option.name);
  };

  getSelectedPrintOptionFilters = () => {
    const selectedIndex = this.props.design.selected_print_option || 0; //TODO test that this actually defaults to 0
    const selectedOption = this.props.productOption.options.find((option) => {
      return option.id === this.props.design.original_option_id;
    });
    const selectedPrintOption = selectedOption.print_options[selectedIndex];
    if (selectedPrintOption) {
      return [...selectedPrintOption.filters];
    } else {
      return [];
    }
  };

  filterOptions = (overrideName, overrideValue) => {
    // start with a copy of all the available options
    let options = [...this.props.productOption.options];

    // grab the list of currently selected filters.
    let selectedFilters = this.getSelectedPrintOptionFilters();

    if (overrideName && overrideValue) {
      // remove all options that don't have the newly selected filter
      options = this.filterOptionsByPrintOptionFilterValue(
        options,
        overrideName,
        overrideValue,
      );

      // now we want to find out which filters (other than the newly selected filter) are actually being used
      // by remaining options.

      // remove the newly selected filter from the list of filters since we already have a list of options with
      // print options that include that filter
      selectedFilters = selectedFilters.filter(
        (filter) => filter.type_name !== overrideName,
      );

      // loop through all options and print options, compile list of remaining filters
      let remainingFilters = [];
      options.forEach((option, optionIndex) => {
        let printOptions = option.print_options.filter((printOption) => {
          let printOptions = printOption.filters.filter(
            (filter) =>
              filter.type_name === overrideName &&
              filter.value === overrideValue,
          );
          return printOptions.length > 0;
        });

        // at this point, printOptions is a list of print options for this option that include the
        // newly selected filter value. we want to grab the other filters that are in use in these print options.
        // those filters are what will be displayed in the Style Tool
        printOptions.forEach((printOption) => {
          printOption.filters.forEach((filter) => {
            if (
              remainingFilters.indexOf(filter.type_name) === -1 &&
              filter.type_name !== overrideName
            ) {
              remainingFilters.push(filter.type_name);
            }
          });
        });
      });

      // remove the filters that we didn't find in the list of print options.
      selectedFilters = selectedFilters.filter(
        (filter) => remainingFilters.indexOf(filter.type_name) !== -1,
      );
    }

    // the order of the filters is important here. we expect the server to send us the filters in an
    // order of descending importance
    //TODO sort them by type_weight
    for (var i = 0; i < selectedFilters.length; i++) {
      let selectedFilterName = selectedFilters[i].type_name;
      let selectedFilterValue = selectedFilters[i].value;

      if (overrideName === selectedFilterName) {
        //override the currently selected filter with the new option
        selectedFilterValue = overrideValue;
      }

      options = this.filterOptionsByPrintOptionFilterValue(
        options,
        selectedFilterName,
        selectedFilterValue,
      );
    }

    return options;
  };

  filterOptionsByPrintOptionFilterValue = (
    options,
    selectedFilterName,
    selectedFilterValue,
  ) => {
    let optionsToRemove = [];
    options.forEach((option, optionIndex) => {
      let shouldRemove = true;
      option.print_options.forEach((printOption) => {
        printOption.filters.forEach((filter) => {
          if (
            filter.type_name === selectedFilterName &&
            filter.value === selectedFilterValue
          ) {
            shouldRemove = false;
          }
        });
      });
      if (shouldRemove) {
        optionsToRemove.push(option);
      }
    });

    optionsToRemove.forEach((optionToRemove) => {
      let removeIndex = options.indexOf(optionToRemove);
      options.splice(removeIndex, 1);
    });
    return options;
  };

  handleHideDialog = () => {
    this.setState({
      showRepousseDialog: false,
    });
  };

  handleHideWarningDialog = () => {
    this.setState({
      showCustomPhotoFoilNote: false,
    });
  };

  render() {
    if (this.props.productOption.options.length === 0) {
      return null;
    }

    const filters = [],
      selectedFilterValues = {};

    this.props.productOption.options.forEach((option) => {
      option.print_options.forEach((printOption, index) => {
        printOption.filters.forEach((filter) => {
          let foundFilter = filters.filter(
            (f) => f.type_name === filter.type_name,
          );
          if (foundFilter.length === 0) {
            filters.push({
              type_id: filter.type_id,
              type_name: filter.type_name,
              shows_thumbnails: filter.type_shows_thumbnails,
              values: [
                {
                  value: filter.value,
                  thumbnail: filter.thumbnail,
                },
              ],
            });
          } else {
            //make sure filter value does not exist in there
            let existing = foundFilter[0].values.filter((value) => {
              return filter.value === value.value;
            });
            if (existing.length === 0) {
              foundFilter[0].values.push({
                value: filter.value,
                thumbnail: filter.thumbnail,
              });
            }
          }

          if (
            option.id === this.props.design.original_option_id &&
            index === this.props.design.selected_print_option
          ) {
            printOption.filters.forEach((filter) => {
              selectedFilterValues[filter.type_name] = filter.value;
            });
          }
        });
      });
    });

    const options = this.filterOptions();

    return (
      <div className="tools-container tools-container--styletools">
        {filters.map((filter) => {
          if (typeof selectedFilterValues[filter.type_name] !== "undefined") {
            return (
              <PrintOptionFilter
                key={filter.type_id}
                id={filter.type_id}
                name={filter.type_name}
                showThumbnails={filter.shows_thumbnails}
                selectedValue={selectedFilterValues[filter.type_name]}
                onChooseOption={this.handleChoosePrintOption}
                printOptions={filter.values}
              />
            );
          } else {
            return null;
          }
        })}

        <OptionList
          options={options}
          onChooseOption={this.handleChooseOption}
        />
        {this.state.showRepousseDialog === true && (
          <div className="step-buttons__dialog">
            <Dialog dialog={this.dialog} onHideDialog={this.handleHideDialog} />
          </div>
        )}
        {this.state.showCustomPhotoFoilNote === true && (
          <div>
            <Dialog
              dialog={this.customPhotoFoilNote}
              onHideDialog={this.handleHideWarningDialog}
            />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    productOption: state.productOption,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
      selectPrintOption,
      updateOption,
      updateDesignName,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StyleTools);
